var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup252(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(-1112 -1040)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star_rate_black_24dp_2_",
    "data-name": "star_rate_black_24dp (2)",
    transform: "translate(1118.818 1040)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    className: "cls-1",
    transform: "translate(.182)",
    d: "M0 0h35v35H0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "m18.849 12.38-2.1-6.915a1.423 1.423 0 0 0-2.729 0l-2.114 6.915H5.548a1.426 1.426 0 0 0-.829 2.586l5.2 3.714-2.042 6.586a1.427 1.427 0 0 0 2.229 1.557l5.272-4 5.272 4.014a1.427 1.427 0 0 0 2.229-1.557l-2.043-6.586 5.2-3.714a1.425 1.425 0 0 0-.829-2.586h-6.358z",
    transform: "translate(1.641 1.781)",
    style: {
      stroke: "#c9c9c9",
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "star_rate_black_24dp_2_2",
    "data-name": "star_rate_black_24dp (2)",
    transform: "translate(1112.437 1044.254)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_122-2",
    "data-name": "Rectangle 122",
    className: "cls-1",
    transform: "translate(-.436 -.255)",
    d: "M0 0h35v35H0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_903-2",
    "data-name": "Path 903",
    d: "m18.849 12.38-2.1-6.915a1.423 1.423 0 0 0-2.729 0l-2.114 6.915H5.548a1.426 1.426 0 0 0-.829 2.586l5.2 3.714-2.042 6.586a1.427 1.427 0 0 0 2.229 1.557l5.272-4 5.272 4.014a1.427 1.427 0 0 0 2.229-1.557l-2.043-6.586 5.2-3.714a1.425 1.425 0 0 0-.829-2.586h-6.358z",
    transform: "translate(1.641 1.781)",
    style: {
      fill: "#dfdfdf"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup252);
export default __webpack_public_path__ + "static/media/Group 252.031d1b75e1b108527e35f32dc5b68a63.svg";
export { ForwardRef as ReactComponent };